/**
 * Formats an ISO 8601 timestamp as a localized `HH:MM` time string in 24-hour format.
 *
 * @param timestamp - An ISO 8601 timestamp (e.g. `"2026-04-14T13:30:00Z"`).
 * @returns The time portion formatted as `HH:MM` using the runtime's locale.
 */
export function formatTime(timestamp: string): string {
  return new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
}
